<template>
  <div>
    <c-row>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Bootstrap Dropdown</strong>
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/dropdown"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            <div>
              <c-dropdown toggler-text="Dropdown Button" class="m-2" color="secondary">
                <c-dropdown-item>First Action</c-dropdown-item>
                <c-dropdown-item>Second Action</c-dropdown-item>
                <c-dropdown-item>Third Action</c-dropdown-item>
                <c-dropdown-divider />
                <c-dropdown-item>Something else here...</c-dropdown-item>
                <c-dropdown-item disabled>Disabled action</c-dropdown-item>
              </c-dropdown>
            </div>
            <!-- <div>
              <CDropdown toggler-text="Dropdown using buttons as menu items" class="m-2">
                <CDropdownItem>I'm a button</CDropdownItem>
                <CDropdownItem>I'm also a button</CDropdownItem>
                <CDropdownItem disabled>I'm a button, but disabled!</CDropdownItem>
                <CDropdownItem>I don't look like a button, but I am!</CDropdownItem>
              </CDropdown>
            </div> -->
            <div>
              <c-dropdown toggler-text="Dropdown with divider" class="m-2" color="secondary">
                <c-dropdown-item>First item</c-dropdown-item>
                <c-dropdown-item>Second item</c-dropdown-item>
                <c-dropdown-divider />
                <c-dropdown-item>Separated Item</c-dropdown-item>
              </c-dropdown>
            </div>
            <div>
              <c-dropdown toggler-text="Dropdown with header" class="m-2" color="secondary">
                <c-dropdown-header>Dropdown header</c-dropdown-header>
                <c-dropdown-item>First item</c-dropdown-item>
                <c-dropdown-item>Second Item</c-dropdown-item>
              </c-dropdown>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Dropdown</strong>
            <small>positioning</small>
          </c-card-header>
          <c-card-body>
            <div>
              <c-dropdown toggler-text="Left align" color="primary" class="m-2 d-inline-block">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here</c-dropdown-item>
              </c-dropdown>
              <c-dropdown placement="bottom-end" toggler-text="Right align" color="primary" class="m-2 d-inline-block">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here</c-dropdown-item>
              </c-dropdown>
            </div>
            <div>
              <c-dropdown toggler-text="Drop-Up" color="info" class="m-2" placement="top-start">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here</c-dropdown-item>
              </c-dropdown>
            </div>
            <div>
              <c-dropdown color="secondary" :offset="[10, 5]" toggler-text="Offset Dropdown" class="m-2">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here</c-dropdown-item>
              </c-dropdown>
            </div>
            <div>
              <c-dropdown color="secondary" split toggler-text="Split Dropdown" class="m-2">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here...</c-dropdown-item>
              </c-dropdown>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Dropdown</strong>
            <small>hidden caret</small>
          </c-card-header>
          <c-card-body>
            <div>
              <c-dropdown color="link" size="lg" :caret="false">
                <template #toggler-content>
                  &#x1f50d;
                  <span class="sr-only">Search</span>
                </template>
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here...</c-dropdown-item>
              </c-dropdown>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Dropdown</strong>
            <small>sizing</small>
          </c-card-header>
          <c-card-body>
            <div>
              <c-dropdown color="secondary" size="lg" toggler-text="Large" class="m-2 d-inline-block">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here</c-dropdown-item>
              </c-dropdown>
              <c-dropdown color="secondary" size="lg" split toggler-text="Large Split" class="m-2">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here...</c-dropdown-item>
              </c-dropdown>
              <br />
              <c-dropdown color="secondary" size="sm" toggler-text="Small" class="m-2 d-inline-block">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here...</c-dropdown-item>
              </c-dropdown>
              <c-dropdown color="secondary" size="sm" split toggler-text="Small Split" class="m-2">
                <c-dropdown-item>Action</c-dropdown-item>
                <c-dropdown-item>Another action</c-dropdown-item>
                <c-dropdown-item>Something else here...</c-dropdown-item>
              </c-dropdown>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Dropdown</strong>
            <small>headers and accessibility</small>
          </c-card-header>
          <c-card-body>
            <div>
              <c-dropdown toggler-text="Dropdown ARIA" color="primary" class="m-2">
                <div role="group">
                  <c-dropdown-header>Groups</c-dropdown-header>
                  <c-dropdown-item>Add</c-dropdown-item>
                  <c-dropdown-item>Delete</c-dropdown-item>
                </div>
                <div role="group">
                  <c-dropdown-header>Users</c-dropdown-header>
                  <c-dropdown-item>Add</c-dropdown-item>
                  <c-dropdown-item>Delete</c-dropdown-item>
                </div>
                <c-dropdown-divider />
                <c-dropdown-item>
                  Something
                  <strong>not</strong>
                  associated with user
                </c-dropdown-item>
              </c-dropdown>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="12" md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Dropdown</strong>
            <small><code>color</code></small>
          </c-card-header>
          <c-card-body>
            <c-dropdown size="sm" toggler-text="Primary" color="primary" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Secondary" color="secondary" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Success" color="success" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Warning" color="warning" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Danger" color="danger" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Info" color="info" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Light" color="light" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Dark" color="dark" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
            <c-dropdown size="sm" toggler-text="Link" color="link" class="m-0 d-inline-block">
              <c-dropdown-item>First Action</c-dropdown-item>
              <c-dropdown-item>Second Action</c-dropdown-item>
              <c-dropdown-item>Third Action</c-dropdown-item>
            </c-dropdown>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Dropdowns',
};
</script>
